import { csrfInterceptor } from "../http-interceptors/CsrfInterceptor.const";
import { HttpService } from "./HttpService";
import { IHttpService } from "./interfaces/IHttpService";

export const httpService: IHttpService = new HttpService();

httpService.registerInterceptor(csrfInterceptor);
